import { render, staticRenderFns } from "./MethodsInfo.vue?vue&type=template&id=045c4a9e&"
import script from "./MethodsInfo.vue?vue&type=script&lang=js&"
export * from "./MethodsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports